module.exports = __webpack_public_path__ + "img/243.food.90bc4b35.svg";